import sanitizeHtml from 'sanitize-html';

// 檢查字數限制
export const handleOverLengthString = (editor, stringMaxLength) => {
    const html = editor.html.get(true);
    const isOverLength = Boolean(stringMaxLength > html.length) ? false : true;

    if (isOverLength) editor.html.set(html.substring(0, stringMaxLength));
};

export function processContent(content = '', callbacks = []) {
    return callbacks.reduce((acc, cb) => cb(acc), content);
}

export function replaceEmptyLink(content = '') {
    return content.replace(/href="#"/gi, () => {
        return 'href="javascript:void(0);"';
    });
}

export function removeHref(content = '') {
    return content.replace(/<a\s+([^>]*?)href="[^"]*"\s*([^>]*)>/gi, '<a $1 $2>');
}

export function sanitizeHtmlCode(content = '') {
    // Default 設定值：https://github.com/apostrophecms/sanitize-html?tab=readme-ov-file#default-options

    return sanitizeHtml(content, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'div']),
        allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            a: [...sanitizeHtml.defaults.allowedAttributes.a, 'style', 'class', 'rel'],
            img: [...sanitizeHtml.defaults.allowedAttributes.img, 'style', 'class'],
            div: ['class', 'style'],
            table: ['class', 'style', 'border', 'cellpadding', 'cellspacing'],
            thead: ['class', 'style', 'border'],
            tbody: ['class', 'style', 'border'],
            tfoot: ['class', 'style', 'border'],
            td: ['class', 'style', 'border'],
            tr: ['class', 'style', 'border'],
            th: ['class', 'style', 'border'],
            span: ['class', 'style'],
            h1: ['class', 'style'],
            h2: ['class', 'style'],
            h3: ['class', 'style'],
            h4: ['class', 'style'],
            p: ['class', 'style']
        },
        parseStyleAttributes: false
    });
}
